(function(angular){
	'use strict';
	
	angular.module('fundriseInvestorsEarnMoreChartModule', [
		'BaseConfig', 
		'highChartsModule',
		'planModule'
	]);

})(window.angular);